var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cp-robot" },
    [
      _c("div", { attrs: { id: "link-robot2s" } }),
      _c("transition", { attrs: { name: "fadeUp" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isTabsVisible,
                expression: "!isTabsVisible"
              }
            ],
            staticClass: "tabs fixed"
          },
          [
            _c("router-link", { attrs: { to: "/robot2s/info" } }, [
              _vm._v("功能")
            ]),
            _c("router-link", { attrs: { to: "/robot2s/design" } }, [
              _vm._v("设计")
            ]),
            _c("router-link", { attrs: { to: "/robot2s/spec" } }, [
              _vm._v("技术规格")
            ])
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "tabs", attrs: { id: "tabs" } },
        [
          _c("router-link", { attrs: { to: "/robot2s/info" } }, [
            _vm._v("功能")
          ]),
          _c("router-link", { attrs: { to: "/robot2s/design" } }, [
            _vm._v("设计")
          ]),
          _c("router-link", { attrs: { to: "/robot2s/spec" } }, [
            _vm._v("技术规格")
          ])
        ],
        1
      ),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ae5b5c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ae5b5c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/robot/2s/index.vue
// module id = 216z
// module chunks = 0